export const IMPROVE_PLAN_MAX = 200;
export const planLength = (value) => Array.from(value ?? "").length;
export const limitPlanInput = (value) => Array.from(value).slice(0, IMPROVE_PLAN_MAX).join("");
